import React from 'react';
import styled from 'styled-components';
import ExternalDatePicker from 'react-datepicker';
import { Controller } from 'react-hook-form';

import type { IFormDatePicker } from './types';

import { Calendar } from '@/assets/icons';
import { YEAR_MONTH_DAY_FORMAT } from '@/config/variables';

const DatePicker = ({ name, control, className, dateFormat, ...rest }: IFormDatePicker): React.ReactElement => (
  <Wrapper>
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <>
          <ExternalDatePicker
            selected={field.value}
            onChange={field.onChange}
            customInput={<Input />}
            disabledKeyboardNavigation
            className={`w-100 ${className}`}
            dateFormat={dateFormat ?? YEAR_MONTH_DAY_FORMAT}
            calendarStartDay={1} // monday
            {...rest}
          />
          <ErrorMessage>{error && error.message}</ErrorMessage>
        </>
      )}
    />
  </Wrapper>
);

export { DatePicker };

const Wrapper = styled.div`
  & > div {
    width: 100%;
  }
`;

const Input = styled.input.attrs({
  className: 'px-3 border rounded-3',
})`
  background-color: #f9fafb;
  background-image: url(${Calendar});
  background-position: right 12px center;
  background-repeat: no-repeat;
  height: 42px;
  width: 100%;
  margin-left: 2px;
  &.form-input {
    height: 48px;
  }
`;

const ErrorMessage = styled.div.attrs({
  className: 'text-danger pt-1',
})`
  font-size: 12px;
  line-height: 12px;
  height: 22px;
`;
